export function BookConsultationPage() {
  return (
    <section aria-labelledby="book-consultation-title">
      <h1 id="book-consultation-title">Book Consultation</h1>
    </section>
  )
}
